const paths = {
  aboutUs: {
    es: 'sobre-nosotros',
    en: 'about-us',
    it: 'su-di-noi',
    pt: 'sobre-nos',
  },

  contribute: {
    es: 'contribuye',
    en: 'contribute',
    it: 'contribuire',
    pt: 'contribuir',
  },

  contactUs: {
    es: 'contactanos',
    en: 'contact-us',
    it: 'contattaci',
    pt: 'contate-nos',
  },

  legal: {
    es: 'nota-legal',
    en: 'legal-notice',
    it: 'informazioni-legali',
    pt: 'representante-legal',
  }
};

export default paths;
